/**
 * @file 向 Gallery 预览 iframe 注入与 home Gallery Report 相同的滚动条样式
 */

/** 读不到 body 背景时的默认轨道色（与 Report 一致） */
const DEFAULT_BG_COLOR = '#EDF0F2';

/** 注入到 iframe 的 style 节点 id */
const IFRAME_SCROLLBAR_STYLE_ID = 'dba-ai-gallery-iframe-scrollbar';

/**
 * 读取 iframe body 背景色，透明则用默认色
 * @param doc - iframe 文档
 * @returns CSS 颜色
 */
const readBodyBg = (doc: Document): string => {
  /** body 计算背景色 */
  const bg = getComputedStyle(doc.body).backgroundColor;
  if (!bg || bg === 'transparent' || bg.startsWith('rgba(0, 0, 0, 0)')) {
    return DEFAULT_BG_COLOR;
  }
  return bg;
};

/**
 * iframe load 后注入 Report 滚动条：4px / #d8dae4 / 轨道跟底色 / hover 才出现。
 * `*` 让报告内代码块等内部滚动条与页面条一致。
 * @param iframe - 预览 iframe
 */
export const injectIframeScrollbarStyle = (
  iframe: HTMLIFrameElement | null,
): void => {
  const doc = iframe?.contentDocument;
  if (!iframe || !doc?.body) {
    return;
  }
  /** 轨道 / 页面底色 */
  const bg = readBodyBg(doc);
  /** 与 home injectScrollbarStyle 相同，并覆盖内部滚动容器 */
  const css = `
html, body {
  overflow-y: hidden !important;
  scrollbar-gutter: stable;
  background-color: ${bg} !important;
}
html:hover, body:hover { overflow-y: auto !important; }
::-webkit-scrollbar,
*::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
  background-color: ${bg} !important;
}
::-webkit-scrollbar-button,
*::-webkit-scrollbar-button { display: none !important; }
::-webkit-scrollbar-track,
::-webkit-scrollbar-corner,
*::-webkit-scrollbar-track,
*::-webkit-scrollbar-corner {
  background-color: ${bg} !important;
}
::-webkit-scrollbar-thumb,
*::-webkit-scrollbar-thumb {
  background-color: #d8dae4 !important;
  border-radius: 8px !important;
}
`;
  /** 复用已有 style 节点 */
  let styleEl = doc.getElementById(IFRAME_SCROLLBAR_STYLE_ID);
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.id = IFRAME_SCROLLBAR_STYLE_ID;
    (doc.head || doc.documentElement).appendChild(styleEl);
  }
  styleEl.textContent = css;
  iframe.style.backgroundColor = bg;
};
